(() => {
  const components = document.querySelectorAll('[data-customer-feedback-intelligence]:not(.cfi--enhanced)');

  components.forEach((component) => component.classList.add('cfi--enhanced'));

  if (!('IntersectionObserver' in window)) {
    components.forEach((component) => component.classList.add('is-ready'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-ready');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  components.forEach((component) => observer.observe(component));
})();
